import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'mono-common-footer-navigation',
    templateUrl: './footer-navigation.component.html'
})
export class FooterNavigationComponent implements OnInit {

    @Input() restartButtonText?: string;
    @Input() progressButtonText: string;
    @Input() canProgress?: boolean = true;
    @Input() disableNavPrevious?: boolean;
    @Input() hideTheFooter?: boolean;
    @Input() showLoader?: boolean = false;
    @Input() previousButtonIcon?: string = "arrow-left";
    @Input() progressButtonIcon?: string = "arrow-right";
    @Input() progressLoadingButtonText?: string;
    @Output() progressClicked = new EventEmitter<any>();
    @Output() previousClicked = new EventEmitter<any>();

    constructor() { }

    ngOnInit(): void {
    }

    public progressButtonClicked($event) {
        this.progressClicked.emit($event);
    }

    public previousButtonClicked($event) {
        this.previousClicked.emit($event);
    }


}
